import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryInteger
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function getHeaders(languages, systemColors) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
  ];

  headers.push(
    new InMemoryHeader({
      title: "headers.member_life_events.category_id",
      type: new InMemoryInteger("CategoryId"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.download_centre.category_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`Category${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  headers.push(
    new InMemoryHeader({
      title: "headers.member_life_events.category_image",
      type: new InMemoryString("CategoryImage", {
        getHtml: (item, type) => {
          if (item.CategoryImage === null || item.CategoryImage === undefined) {
            return "";
          }
          return (
            `<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>
            <a href="${item.CategoryImage}" target="_blank">${item.CategoryImage}</a>
            </div>`
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.member_life_events.category_text_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`CategoryText${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  return headers;
}
export default getHeaders;
